module.exports = __webpack_public_path__ + "static/media/8-iveco-mercedes.c069a97b.jpg";